/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var MoneyCurrencyRubleRectIcon20Light = forwardRef('MoneyCurrencyRubleRectIcon20Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9 11h2a2.5 2.5 0 0 0 0-5H8.714A.714.714 0 0 0 8 6.714V10h-.5a.5.5 0 0 0 0 1H8v1h-.5a.5.5 0 0 0 0 1H8v.75a.5.5 0 0 0 1 0V13h2.5a.5.5 0 0 0 0-1H9v-1Zm0-4v3h2a1.5 1.5 0 0 0 0-3H9Z" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2 7a3 3 0 0 1 3-3h10a3 3 0 0 1 3 3v6a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3V7Zm3-2a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2H5Z" })));
});
